// extracted by mini-css-extract-plugin
module.exports = {"Progress":"Progress--POCNR","circle-bar":"circle-bar--n9cCM"};